import { useState } from 'react';

import Button from 'components/shared/Button/Button';
import Dot from 'components/shared/Dot/Dot';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

import { buildPreAuthTerms } from '../lib/helpers';

const TermItem = ({ segments }) => (
  <div className="flex gap-1">
    <div className="flex h-6 w-6 shrink-0 items-center justify-center">
      <Dot size="sm" color="neutral" className="w-fit shrink-0" />
    </div>
    <Typography variant="p" size="small">
      <span>
        {segments.map((segment, idx) =>
          segment.bold ? (
            <span key={idx} className="font-semibold">
              {segment.text}
            </span>
          ) : (
            <span key={idx}>{segment.text}</span>
          )
        )}
      </span>
    </Typography>
  </div>
);

const PreAuthTerms = ({ phase, amounts, oonResponsibility = null }) => {
  const [isOpen, setIsOpen] = useState(true);
  const terms = buildPreAuthTerms(phase, undefined, amounts, oonResponsibility);

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-solid border-neutral-200 bg-neutral-50 p-3">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1">
          <Icon icon="document-text-mono" size={18} />
          <Typography variant="p" size="small" weight="medium">
            Additional pre-authorized terms
          </Typography>
        </div>
        <Button
          text={!isOpen ? 'Show Terms' : 'Hide Terms'}
          variant="link"
          size="xs"
          onClick={() => setIsOpen((prev) => !prev)}
        />
      </div>
      {isOpen && (
        <>
          <div className="flex flex-col gap-2">
            {terms.map((segments, idx) => (
              <TermItem key={idx} segments={segments} />
            ))}
          </div>
          <Typography variant="p" size="xs" color="neutral-600" className="italic">
            These terms apply to all pre-authorized transaction types processed under this form.
          </Typography>
        </>
      )}
    </div>
  );
};

export default PreAuthTerms;
